<template>
    <v-container>
        <v-card>
            <v-card-text v-if="confirmed">
                <p class="title">{{'Congratulations, your email is confirmed!' | translation}}</p>
                <p class="mb-0">
                    {{'Now you can' | translation}}
                    <a href="#" @click.prevent="setShowLoginModal(true)">{{'Login' | translation}}</a>
                    {{'using email and password' | translation}}
                </p>
            </v-card-text>
            <v-card-text v-else-if="error">{{error | translation}}</v-card-text>
            <v-card-text v-else> {{'Confirming' | translation}}</v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import Vue from 'vue';
    import {mapMutations, mapActions} from 'vuex';
    import module from './store';
    import Login from '../LoginForm';

    const moduleName = 'ConfirmRegistration';

    if (!(Vue.$store.state[moduleName])) {
        Vue.$store.registerModule(moduleName, module);
    }

    export default {
        name: moduleName,
        data() {
            return {
                confirmed: false,
                error: false,
            };
        },
        mounted() {
            if (this.$route.params.hash) {
                this.confirmRegistration({
                    hash: this.$route.params.hash,
                })
                    .then(result => {
                        if (result) {
                            this.confirmed = true;
                        } else {
                            this.error = 'The hash is incorrect, or account already confirmed.';
                        }
                    })
                    .catch(() => {
                        this.error = 'The hash is incorrect, or account already confirmed.';
                    });
            } else {
                this.error = 'No confirmation hash provided';
            }
        },
        methods: {
            ...mapMutations(Login.name, [
                'setShowLoginModal',
            ]),
            ...mapActions(moduleName, [
                'confirmRegistration',
            ]),
        },
    };
</script>